var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLineSegments = function SvgIconLineSegments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.661 8.447q.287.053.589.053a3.25 3.25 0 1 0-2.349-1.003l-2.313 4.306a3.27 3.27 0 0 0-2.068.303l-1.626-1.626a3.25 3.25 0 1 0-5.243.766l-2.313 4.307a3.25 3.25 0 1 0 1.76.95l2.313-4.306a3.27 3.27 0 0 0 2.069-.303l1.626 1.626a3.25 3.25 0 1 0 5.242-.767zM20.25 4a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m-4.698 9.878.082.045a1.25 1.25 0 1 1-.082-.045M9 7.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m-4.698 9.878.082.045a1.25 1.25 0 1 1-.082-.045",
    clipRule: "evenodd"
  })));
};
export default SvgIconLineSegments;